import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Card,
  CardContent,
  Typography,
  Divider,
  Link
} from '@material-ui/core';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import BuildIcon from '@material-ui/icons/Build';
import { FaMoneyBillWave } from "react-icons/fa";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  inday: {
    color: colors.green[600]
  },
  cpclate: {
    color: colors.red[600]
  },
  cpalate: {
    color: colors.red[600]
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    if (value == '') {
      return 'Não Definido'
    } else {
      return value;
    }
  }
}

const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Record = ({ icon, item, vision, resultMode, openEdition, openDeletion, openTreatment, openExportDialog, slas }) => {

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    if (event.currentTarget.id == 'excel' || event.currentTarget.id == 'csv' || event.currentTarget.id == 'pdf') {
      openExportDialog(event.currentTarget.id);
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    setAnchorEl(null);
  };


  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getStatusSLA = (slas, column, item) => {
    if (item.TIPO_OCORR == 2 || item.TIPO_OCORR == 4) {
      return "";
    } else {
      var style = 0;
      if (column.name == 'CPA' || column.name == 'CPC') {
        var group = (column.name == 'CPA') ? 1 : (column.name == 'CPC') ? 2 : 0;
        slas.forEach(sla => {
          if (sla.ocorrencia == item.id) {
            style = (sla.grupo == 3) ? 3 : group;
          }
        });
      }
      var ret = (style == 1) ? classes.cpalate : (style == 2) ? classes.cpclate : (style == 3) ? classes.inday : "";
      return ret;
    }
  }

  const getIconColor = (item) => {
    if (item.realizado == 3) {
      return { color: colors.green[600] }
    } else if (item.servicoExecutado || item.horasExecucaoServico || item.dataConclusaoAtendimento || item.dataInicioAtendimento) {
      return { color: colors.yellow[600] }
    } else {
      return { color: colors.red[600] }
    }
  }


  return (
    <Fragment>

      <Grid
        item
        lg={3}
        md={6}
        xs={12}
      >
        <Card className={classes.root}>

          <CardContent>

            <Tooltip title={(item.ORCAMENTO != null) ? 'Valor de Orçamento Registrado: ' + numeral(item.ORCAMENTO).format('0.00') : "Sem Orçamento Registrado"}>
              <Box
                display="flex"
                justifyContent="center"
                mb={1}
              >
                {(item.ORCAMENTO != null) ? (item.ORCAMENTO > 0) ? <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, width: '16px', color: colors.green[500] }} ></Icon> : <Icon component={FaMoneyBillWave} style={{ marginLeft: -14, width: '16px', color: colors.red[500] }} ></Icon> : ""}
                <Avatar
                  className={classes.avatar}
                >
                  <Icon component={icon} style={getIconColor(item)} ></Icon>
                </Avatar>
                
              </Box>
            </Tooltip>

            <Typography
              align="center"
              color="textPrimary"
              gutterBottom
              variant="h4"
            >
              {(resultMode.update == LEVEL_ACCESS_ENABLED && resultMode.update != LEVEL_ACCESS_HIDE) ? (
                <Link
                  onClick={() => { openEdition(item) }}
                >
                  <b>{getFieldValue(resultMode.columns[0])}</b>
                </Link>
              ) : (
                <b>{getFieldValue(resultMode.columns[0])}</b>
              )}
            </Typography>

            <Typography
              align="center"
              color="textPrimary"
              variant="body1"
            >
              <b>{getFieldValue(resultMode.columns[1])} - {getFieldValue(resultMode.columns[2])}</b>
            </Typography>


            {resultMode.columns.map((col, index) => (
              (index > 2) ? (
                <Typography
                  noWrap={(col.wrap)}
                  className={getStatusSLA(slas, col, item)}
                  align="center"
                  color="secondary"
                  variant="h5"
                >
                  <b>{col.name}:</b> {getFieldValue(col)}
                </Typography>
              ) : (
                ""
              )
            ))}

          </CardContent>

          <Divider />

          <Box p={1}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={1}
            >
              <Grid item>
                <Grid container
                  style={{ maxWidth: 150, minWidth: 150 }}
                >
                  {(resultMode.config != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title="Tratar">
                        <IconButton
                          color="secondary"
                          disabled={resultMode.config == LEVEL_ACCESS_DISABLED}
                          children={<BuildIcon />}
                          size="medium"
                          onClick={() => { openTreatment(item) }}></IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                  {(resultMode.update != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title="Editar">
                        <IconButton
                          color="secondary"
                          disabled={resultMode.update == LEVEL_ACCESS_DISABLED}
                          children={<EditRoundedIcon />}
                          size="medium"
                          onClick={() => { openEdition(item) }}>
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                  {(resultMode.delete != LEVEL_ACCESS_HIDE) ? (
                    <Grid item
                      md={4}
                      xl={4}
                    >
                      <Tooltip title={"Excluir"}>
                        <IconButton
                          color="secondary"
                          disabled={resultMode.delete == LEVEL_ACCESS_DISABLED}
                          children={<DeleteRoundedIcon />}
                          size="medium"
                          onClick={() => { openDeletion(item) }}></IconButton>
                      </Tooltip>
                    </Grid>
                  ) : ('')}

                </Grid>
              </Grid>

              <Grid
                item
              >
              </Grid>
            </Grid>
          </Box>
        </Card>

      </Grid>

    </Fragment>
  );
}

export default Record;